/* src/app/style/side-menu.scss */
:host {
  --page-margin: var(--app-fair-margin);
  --page-background: var(--app-background-alt-shade);
  --page-headers-shadow-color: rgba(var(--ion-color-darkest-rgb), 0.4);
}
.app-sidemenu ion-toolbar {
  --padding-start: 0px;
  --padding-end: 0px;
  --padding-top: 0px;
  --padding-bottom: 0px;
  --background: #1c1c1c;
}
.app-sidemenu ion-content {
  --background: var(--page-background);
}
.app-sidemenu .user-details-wrapper {
  --ion-grid-column-padding: 0px;
  color: var(--ion-color-lightest);
  padding: var(--page-margin);
  align-items: center;
}
.app-sidemenu .user-details-wrapper + .user-details-wrapper {
  padding-top: 0px;
}
.app-sidemenu .user-info-wrapper {
  padding-left: var(--page-margin);
}
.app-sidemenu .user-info-wrapper .user-name {
  margin: 0px 0px 5px;
}
.app-sidemenu .user-info-wrapper .user-handle {
  color: var(--ion-color-light-shade);
  margin: 0px;
  font-size: 14px;
  font-weight: 400;
}
.app-sidemenu .user-stats-wrapper {
  text-align: center;
}
.app-sidemenu .user-stats-wrapper .user-stat-value {
  margin-right: 5px;
  font-weight: 500;
}
.app-sidemenu .user-stats-wrapper .user-stat-name {
  color: var(--ion-color-light-shade);
  font-size: 14px;
}
.app-sidemenu ion-list {
  --ion-text-color: var(--ion-color-light-shade);
  --ion-text-color-rgb: var(--ion-color-light-shade-rgb);
  --ion-item-background: var(--page-background);
  --ion-item-border-color: transparent;
}
.app-sidemenu ion-list ion-list-header {
  --color: rgba(var(--ion-color-light-shade-rgb), 0.6);
  text-transform: uppercase;
  box-shadow: inset 0px -4px 8px -2px var(--page-headers-shadow-color);
  padding-inline-start: var(--page-margin);
  font-size: 14px;
  margin-bottom: 8px;
}
.app-sidemenu ion-list ion-item {
  --border-width: 0px !important;
  --padding-start: var(--page-margin);
}
.app-sidemenu ion-list ion-icon {
  color: var(--ion-color-light-shade);
}
.app-sidemenu ion-list ion-label {
  color: #dadada;
}
/*# sourceMappingURL=side-menu.css.map */
